import { useState, useEffect, useContext } from "react";
import { getPackageDealById } from "api/PackageDeals";
import { CurrencyContext } from "pages/useContext";

function usePackageDeal(id) {
  const { currency } = useContext(CurrencyContext);
  const [deal, setDeal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!id) {
      setDeal(null);
      setLoading(false);
      setError(false);
      return;
    }

    let cancelled = false;
    const isInitialLoad = !deal;
    if (isInitialLoad) setLoading(true);
    setError(false);

    getPackageDealById(id, currency)
      .then((response) => {
        if (cancelled) return;
        if (isInitialLoad) setLoading(false);
        if (response.ok && response.data) {
          setDeal(response.data);
        } else {
          setError(true);
        }
      })
      .catch(() => {
        if (cancelled) return;
        if (isInitialLoad) setLoading(false);
        setError(true);
      });

    return () => {
      cancelled = true;
    };
  }, [id, currency?.currency]);

  return { deal, loading, error };
}

export default usePackageDeal;
